import React from "react";
import { Button } from "components/ui";
import OriAvatar from "components/ori/OriAvatar";
import { useTranslation } from "lib/i18n/use-translation";
import AssessmentUpliftHeader from "./AssessmentUpliftHeader";
import ProgressPill, { ProgressPillProps } from "./ProgressPill";
import AssessmentStepTransition from "./AssessmentStepTransition";
import styles from "./AssessmentSectionUplift.module.scss";

export interface AssessmentSectionUpliftProps {
  stepKey: string;
  titleHtml?: string | null;
  subtitleHtml?: string | null;
  onContinue: () => void;
  onBack?: () => void;
  onClose: () => void;
  progressPill?: ProgressPillProps | null;
}

const AssessmentSectionUplift: React.FC<AssessmentSectionUpliftProps> = ({
  stepKey,
  titleHtml,
  subtitleHtml,
  onContinue,
  onBack,
  onClose,
  progressPill,
}) => {
  const { t } = useTranslation(["assessment"]);

  return (
    <div className={styles.container} data-testid="assessment-section-uplift">
      <AssessmentUpliftHeader onBack={onBack} onClose={onClose} />

      {progressPill && (
        <div className={styles["pill-row"]}>
          <ProgressPill {...progressPill} />
        </div>
      )}

      <div className={styles.body}>
        <AssessmentStepTransition stepKey={stepKey}>
          <div className={styles.content}>
            <div className={styles["ori-row"]}>
              <OriAvatar size={56} />
              <p className={styles["ori-name"]}>{t("assessment:uplift.oriName")}</p>
            </div>

            {titleHtml && (
              <h1
                className={styles.heading}
                dangerouslySetInnerHTML={{ __html: titleHtml }}
              />
            )}

            {subtitleHtml && (
              <p
                className={styles.paragraph}
                dangerouslySetInnerHTML={{ __html: subtitleHtml }}
              />
            )}

            <Button
              variant="enclosed-primary"
              monochromeColour="black"
              className={styles["continue-button"]}
              onClick={onContinue}
            >
              {t("assessment:section.continue")}
            </Button>
          </div>
        </AssessmentStepTransition>
      </div>
    </div>
  );
};

export default AssessmentSectionUplift;
